//
//
//
//
//
//
//


export default {
  props: {
    product: String,
    contentHtml: String,
    contentImages: Array,
    bottomSpacer: Boolean
  },
  computed: {
    productFilter () {
      const htmlparser = require('htmlparser2')
      const render = require('dom-serializer').default
      const { Element } = require('domhandler')
      const dom = htmlparser.parseDocument(this.contentHtml, { xml: true, recognizeSelfClosing: true })

      this.walk(dom, this.product, this.contentImages, this, function (node, product, contentImages, that) {
        if (node.name === 'img') {
          let imageURL = null
          let imageWidth = 100
          let imageMargin = '0'
          if (contentImages) {
            node.attributes.forEach((attribute) => {
              if (attribute.name === 'src') {
                const srcLwr = attribute.value.toLowerCase()
                contentImages.forEach((image) => {
                  if (image.image && image.image.name) {
                    const nameLwr = image.image.name.toLowerCase()
                    if (srcLwr === nameLwr) {
                      imageURL = that.assetUrl(image.image.url)
                      imageWidth = image.widthPercent ? image.widthPercent : 100
                      imageMargin = image.centerAlign ? 'auto' : '0'
                    }
                  }
                })
              }
            })
          }

          if (imageURL) {
            const el = new Element(node.name, { src: imageURL, width: imageWidth + '%', style: 'display:block;margin-top:0.75rem;margin-bottom:0.75rem;margin-left:' + imageMargin + ';margin-right:' + imageMargin + ';', class: 'xdocs-image' }, htmlparser.DomUtils.getChildren(node))
            htmlparser.DomUtils.replaceElement(node, el)
          } else {
            htmlparser.DomUtils.removeElement(node)
          }
        }

        if (node.attributes) {
          node.attributes.forEach((attribute) => {
            if ((attribute.name === 'product') && (!product || new RegExp('\\b' + product + '\\b').test(attribute.value) !== true)) {
              htmlparser.DomUtils.removeElement(node)
            }
          })
        }
      })

      let html = null
      let nodes = htmlparser.DomUtils.getElementsByTagName('conbody', dom)

      if (!nodes.length) {
        nodes = htmlparser.DomUtils.getElementsByTagName('refbody', dom)
      }
      if (!nodes.length) {
        nodes = htmlparser.DomUtils.getElementsByTagName('body', dom)
      }
      if (nodes.length) {
        html = render(nodes[0])
      }

      return html
    }
  },
  methods: {
    walk (node, product, contentImages, that, func) {
      func(node, product, contentImages, that)

      node = (node.children && node.children.length)
        ? node.children[0]
        : null

      while (node) {
        this.walk(node, product, contentImages, that, func)
        node = node.next
      }
    }
  }
}
